<div class="contact-management">
  <h1 class="contact-management__title">Керування контактами</h1>

  <mat-card class="contact-management__card">
    <mat-card-header>
      <mat-card-title>Дії</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="contact-management__buttons">
        <button mat-raised-button color="primary" (click)="fixPhones()" [disabled]="isFixingPhones">
          {{ isFixingPhones ? 'Виправляємо...' : 'Виправити телефони' }}
        </button>

        <button mat-raised-button color="accent" (click)="fixSocialLinks()" [disabled]="isFixingSocialLinks">
          {{ isFixingSocialLinks ? 'Виправляємо...' : 'Виправити посилання' }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
